import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetSubscriptionsParams, SubscriptionsSchema } from './types';
import { SubscriptionsService } from '../services';

const IDLE = 'idle' as const;

const initialState: SubscriptionsSchema = {
  hasMetaplans: {
    data: null,
    status: IDLE,
  },
  subscriptionsList: {
    data: null,
    status: IDLE,
  },
};

export const hasMetaplansAction = createAsyncThunk(
  'subscriptions/hasMetaplansAction',
  async () => await SubscriptionsService.hasMetaplans(),
);

export const getSubscriptionsAction = createAsyncThunk(
  'subscriptions/getSubscriptionsAction',
  async (params?: GetSubscriptionsParams) =>
    await SubscriptionsService.getSubscriptions(params),
);

const subscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hasMetaplansAction.pending, (state) => {
        state.hasMetaplans.status = 'loading';
      })
      .addCase(hasMetaplansAction.fulfilled, (state, action) => {
        state.hasMetaplans.data = action.payload;
        state.hasMetaplans.status = 'success';
      })
      .addCase(hasMetaplansAction.rejected, (state) => {
        state.hasMetaplans.status = 'error';
      })
      .addCase(getSubscriptionsAction.pending, (state) => {
        state.subscriptionsList.status = 'loading';
      })
      .addCase(getSubscriptionsAction.fulfilled, (state, action) => {
        state.subscriptionsList.data = action.payload;
        state.subscriptionsList.status = 'success';
      })
      .addCase(getSubscriptionsAction.rejected, (state) => {
        state.subscriptionsList.status = 'error';
      });
  },
});

export const { reducer } = subscriptionsSlice;
